export default "__VITE_ASSET__D3Eg4T3a__"